let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iNoMF")).then(() => parcelRequire('fuz0W'));